<template>
  <tile class="opc-zmone opc-zmone--delta" :class="{
    'opc-zmone-delta-modal': $context.is.modalDelta
  }">
    <EditDeltaViewCurrent ref="EditDeltaViewCurrent" :trackingName="title" />
    <PlanDetail v-show="false" ref="planDetail" />
    <foldable
      v-model="isExpanded"
      :title="title"
      :arrow="canExpand"
      :edit="canExpand"
      :isRemoveWrapAriaLabelledby="true"
    >
      <div slot="head">
        <div class="opc-zm-base-card__head">
          <div class="opc-zm-base-card__head-left">
            <img class="opc-zm-base-card__logo" :src="logo" :alt="title" />
          </div>
          <div class="opc-zm-base-card__head-right">
            <h2 class="opc-zm-base-card__name text-capitalize">
              {{ title }}
              <i class="zm-icon-success main-icon"></i>
            </h2>
            <div class="opc-zm-base-card__collapse" v-if="isExpanded && $context.is.modal">
              <zm-button data-testid="checkout-button-136" class="opc-zm-base-card__link" type="link" @click="viewCurrent">
                {{ $t('billing.delta.cur_plan_detail') }}
              </zm-button>
            </div>
            <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
              {{ expandedPlanDesc }}
            </div>
          </div>
        </div>
      </div>
      <div class="opc-zmone__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form">
          <zm-form-item>
            <template>
              <template v-if="$context.is.modal">
                <p class="opc-zmone__form-label" slot="label">{{ $t('billing.delta.buy_more_licenses') }}</p>
                <div class="opc-zmone__form-modal-tips">
                  <span>{{ deltaCurUserTipsForModal }}</span>
                </div>
              </template>
              <template v-else>
                <p class="opc-zmone__form-label" slot="label">{{ $t('billing.delta.add_user') }}</p>
                <div class="opc-zmone__form-modal-tips">
                  <span>{{ $t('billing.delta.cur_users', { X: boughtMeetingPlan.cartInfo.selected_number }) }}</span>
                  <zm-button data-testid="checkout-button-137" class="opc-zm-base-card__link" type="link" @click="viewCurrent">
                    {{ $t('billing.delta.cur_plan_detail') }}
                  </zm-button>
                </div>
              </template>
            </template>
            <div class="opc-zmone__form-input-wrapper">
              <InputNumberWithPopover
                class="opc-zmone__quantity-selector"
                v-model="deltaForm.selectedNumber"
                size="large"
                controls-position="both"
                :min="1"
                :max="maxHost"
                :label="`${title} Select the number of users`"
                :decrease-tips="popUpDecreaseTips"
                :increase-tips="increaseTips"
              />
              <template v-if="$context.is.modal">
                <span class="opc-modal-tips-title">
                  {{ $t('billing.delta.new_licenses') }}
                </span>
                <span class="opc-modal-billing-cycle">
                  <inline-price :price="currentBillingCyclePrice.price"></inline-price>
                  <span class="opc-modal-cycle-info">
                    {{ currentBillingCyclePrice.unit }},
                    {{ getBillText(currentEditPlan.billing_cycle) }}
                  </span>
                </span>
              </template>
            </div>
          </zm-form-item>
          <zm-form-item class="opc-config-form__last-item" v-if="!$context.is.modal">
            <zm-radio-group
              v-model="form.billingCycle"
              class="opc-card-radio"
              :aria-label="`${title} Billing Cycle`"
              @change="submitForm"
            >
              <zm-radio
                v-for="plan in currentPlans"
                data-testid="checkout-radio-138"
                :key="plan.billing_cycle"
                :label="plan.billing_cycle"
                :disabled="billingCycleDisabled(plan)"
                class="opc-zmone__radio"
              >
                <p class="opc-zmone__radio-title text-capitalize">
                  {{ $t(`billing.billing_cycle.${plan.billing_cycle}`) }}
                </p>
                <p class="opc-product-price-container" tabindex="-1">
                  <span
                    v-for="(value, key, index) in getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true })"
                    :key="index"
                    :class="[
                      `opc-product-price-container__${key}`,
                      useSmallSize(value) ? 'opc-product-price-container__small' : '',
                    ]"
                    :style="value.symbol && value.place === 'end' ? { order: 1 } : {}"
                  >
                    {{ value.symbol ? value.symbol : value }}
                  </span>
                </p>
                <p
                  class="opc-zmone__radio-price-unit opc-price-bill-text"
                 >
                <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount)"></span><priceVATTip />
                </p>
              </zm-radio>
            </zm-radio-group>
          </zm-form-item>
          <preview-payment />
        </zm-form>
      </div>
    </foldable>
  </tile>
</template>

<script>
import { pageConfig } from '@/common/service/page-config';
import { ZOOM_MEETING_SUB_TYPES } from '../common/utils';
import edit from './edit.vue';
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import EditDeltaViewCurrent from './edit-delta-view-current.vue';
import offerNotEligible from '@/components/offer-not-eligible';
import { categories } from '../cart.vue';
import { PLAN_PRICE_CHANGE_UTILS } from '@/common/priceChange';
import { PREVIEW_ACTION_TYPES } from '@/store/modules/preview';
import { planTypes } from '@/common/constants';
import PlanDetail from '../cart.vue';
import InlinePrice from '@/components/inline-price.vue';

import { getPlanUnitWithCycle, planUnitMap } from '@/common/product-unit';
import { BILLING_CYCLE, NO_NEED_CHANGE_PRICE_CYCLE } from '@/common/constants';


export default {
  mixins: [edit],
  data() {
    return {
      deltaForm: {
        selectedNumber: 1,
      },
    };
  },
  computed: {
    ...mapGetters(['preloadCartInfo', 'planMapFlatRaw', 'hasPendingRequest', 'boughtPlans', 'getSelectedPlans']),
    deltaCurUserTipsForModal() {
      const userQuantity = this.boughtMeetingPlan.cartInfo.selected_number;

      if (this.form.category === ZOOM_MEETING_SUB_TYPES.PRO) {
        return userQuantity > 1 ? this.$t('billing.delta.cur_users_modal_multiple', { X: userQuantity })
          : this.$t('billing.delta.cur_users_modal_single');
      }

      return this.$t('billing.delta.cur_users', { X: userQuantity });
    },
    currentEditPlan() {
      return this.currentPlans.find((p) => p.plan_code === this.oldPlanCode);
    },
    currentBillingCyclePrice() {
      const unit = this.$context.is.modalDelta ? planUnitMap.license : planUnitMap.user;

      return {
        price: (this.currentEditPlan.amount / 100).toFixed(2),
        unit: getPlanUnitWithCycle(this.currentEditPlan.billing_cycle, unit),
      };
    },
    mimicProratedCharges() {
      const plan = plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).get(0); // this is edit flow
      const $vm = this.$refs.planDetail;
      const deltaAmount = $vm?.mx_price_delta?.(plan) ?? 0;
      const deltaLicense = $vm?.mx_license_delta?.(plan) ?? 0;
      const boughtLicense = $vm?.mx_license_bought?.(plan) ?? 1;
      // getters.getTaxTotalAmount is polluted by INR checkout
      const getTaxTotalAmount = this.$store.state.Tax.taxes.reduce((acc, x) => {
        const planTax = x.tax.reduce((acc, y) => {
          return acc + y.taxAmount;
        }, 0);
        return acc + planTax;
      }, 0);
      const proratedTax = (getTaxTotalAmount * deltaLicense) / (deltaLicense + boughtLicense);
      const totalAmount = deltaAmount + proratedTax;
      return {
        amount: 0,
        taxAmount: proratedTax,
        totalAmount,
      };
    },
    maxHost() {
      return this.maxHostInfo.max;
    },
    maxHostInfo() {
      if (this.$context.is.modal && this.form.category === ZOOM_MEETING_SUB_TYPES.PRO) {
        return {
          max: 99,
          tips: this.$t('billing.error.cant_add_100'),
        };
      }
      return {
        max: 9999,
        tips: '',
      };
    },
    expandedPlanDesc() {
      const quantity = this.deltaForm.selectedNumber;
      const amount = this.$money(this.formPlan ? this.formPlan.amount : 0);
      const unitDesc = this.getPlanUnitWithCycle(this.form.billingCycle);

      return this.$context.is.modalDelta ?
        `${this.$t('billing.unit.license', [quantity])} •  ${amount}${unitDesc}`
        : this.$t('billing.zone.desc1', [ quantity, amount, unitDesc ]);
    }
  },
  components: {
    EditDeltaViewCurrent,
    PlanDetail,
    InlinePrice,
  },
  watch: {
    mimicProratedCharges: {
      deep: true,
      async handler() {
        // todo can use implemented prorated price, remove this watch
        if (this.$context.is.modalDelta) return;

        this.$nextTick(() => {
          this.$store.dispatch(PREVIEW_ACTION_TYPES.resetProratedCharges);
          this.$store.commit('setProratedChargeAmount', this.mimicProratedCharges.amount);
          this.$store.commit('setProratedChargeTaxAmount', this.mimicProratedCharges.taxAmount);
          this.$store.commit('setProratedChargeTotalAmount', this.mimicProratedCharges.totalAmount);
        });
      },
    },
    'deltaForm.selectedNumber': {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          const selectedNumber =
            (this.boughtMeetingPlan?.cartInfo?.selected_number ?? 0) + this.deltaForm.selectedNumber;
          this.form.selectedNumber = selectedNumber;
          this.submitForm(selectedNumber);
        });
      },
    },
  },
  methods: {
    getPlanUnitWithCycle(billingCycle) {
      return getPlanUnitWithCycle(billingCycle, this.$context.is.modalDelta ? planUnitMap.license : planUnitMap.user);
    },
    init() {
      // cart builder plan planCode is not accurate due to different billing cycle that sales rep may choose
      // we need to get added quantity from the cart builder plan of current edit type
      const oldPlanCode = pageConfig.oldPlanCode;
      if (this.getSelectedPlans.length > 1) return offerNotEligible(); // disable scenarios with incidental plans, e.g. US & CA Audio Conferencing
      if (this.hasPendingRequest[oldPlanCode]) return offerNotEligible();
      const currentEditPlan = this.planMapFlatRaw.find((x) =>
        [oldPlanCode, PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(oldPlanCode)].includes(x.plan_code),
      );
      if (!currentEditPlan) return offerNotEligible();
      const editPlanType = currentEditPlan?.type;
      const boughtPlan = plansof(this.boughtPlans).type(editPlanType).get(0);
      if (!boughtPlan || boughtPlan?.isFreeTrial) return offerNotEligible();
      const editPlanCategory = currentEditPlan?.category;
      if (!editPlanType || !editPlanCategory) return;
      const plansOfEditType = plansof(this.planMapFlatRaw).type(editPlanType).category(editPlanCategory).get();
      const allPlanCodesOfEditType = plansOfEditType.map((x) => x.plan_code);
      const changedPriceCodes = allPlanCodesOfEditType.map((planCode) =>
        PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(planCode),
      );
      if (this.$context.is.modal) {
        let addQty = Number(pageConfig.addQty);
        addQty = addQty < 1 ?
          1 :
          addQty > 99 ?
            99 :
            addQty;
        this.deltaForm.selectedNumber = addQty;
      } else {
        const cartPlans = this.preloadCartInfo?.orderData?.planList;
        const targetPlan = cartPlans?.find((x) =>
          [...changedPriceCodes, ...allPlanCodesOfEditType].includes(x.planCode),
        );
        if (!targetPlan) {
          const allPlansOfEditType = plansof(this.planMapFlatRaw).type(editPlanType).get();
          const offeredPlanCategory =
            allPlansOfEditType.find((x) => {
              const cartPlanCodes = cartPlans.map((x) => x.planCode);
              const planCode = x.plan_code;
              const priceChangePlanCode = PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(planCode);
              return cartPlanCodes.includes(x.plan_code) || cartPlanCodes.includes(priceChangePlanCode);
            })?.category ?? '';
          return offerNotEligible(
            offeredPlanCategory &&
              `${this.$t('billing.delta.offer_exclusive_to', [this.$t(categories[offeredPlanCategory] ?? '')])}`,
          );
        }
        this.deltaForm.selectedNumber = Math.max(targetPlan.quantity, 1);
      }
    },
    async viewCurrent() {
      this.$tracking.buyInteraction('view current plan details selected', this.title);
      await this.$refs.EditDeltaViewCurrent.$popup();
    },
    getBillText(billingCycle) {
      if (NO_NEED_CHANGE_PRICE_CYCLE.includes(billingCycle)) {
        return this.$t('billing.bill_monthly')
      }
      switch (billingCycle) {
        case BILLING_CYCLE.ANNUAL:
          return this.$t('billing.bill_annually')
        case BILLING_CYCLE.QUARTERLY:
          return this.$t('billing.bill_quarterly')
        case BILLING_CYCLE.TWO_YEARS:
          return this.$t('billing.bill_two_years')
        case BILLING_CYCLE.THREE_YEARS:
          return this.$t('billing.bill_three_years')
      }
      return ''
    },
  },
  mounted() {
    setTimeout(this.init, 0);
  },
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-zmone--delta {
  .opc-card-radio {
    @include media(desktop) {
      width: 50%;
    }
    .opc-price-save-count {
      display: none;
    }
    .zm-radio__label.is-checked {
      .zm-radio__label--inner {
        border: 1px solid #b8b8c4;
      }
      &:after {
        display: none;
      }
    }
    .zm-radio__label:not(.is-checked) {
      display: none;
    }
    :has(.zm-radio__label:not(.is-checked)) {
      display: none;
    }
  }
  .opc-zmone__main {
    .opc-config-form {
      .opc-zmone__form-modal-tips {
        display: flex;
        justify-content: start;
        align-items: baseline;
        .opc-zm-base-card__link {
          margin-left: 4px;
        }
      }
      .opc-zmone__form-input-wrapper {
        display: flex;
        align-items: baseline;
        margin-top: 12px;
        .opc-zmone__quantity-selector {
          margin-top: 0;
        }
      }
    }
    .opc-modal-tips-title {
      font-size: 16px;
      font-weight: 600;
      margin: 0 8px;
      flex-shrink: 0;
    }
    .opc-modal-billing-cycle {
      margin-left: 40px;
      display: inline-flex;
      flex-wrap: wrap;
      gap: 8px;
      .opc-modal-cycle-info {
        color: #6e7680;
      }
    }
  }
}

.opc-zmone--delta {
  &.opc-zmone-delta-modal {
    .opc-zm-base-card__name {
      @include media(mobile, tablet) {
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%; /* 30px */
      }
    }

    .opc-zm-base-card__collapse {
      margin-top: 0px;
    }
  }
}

</style>
